import { ILeadRepository } from '../../../domain/repositories/ILeadRepository';

export class DeleteLeadUseCase {
    constructor(private readonly leadRepository: ILeadRepository) { }

    async execute(leadId: string): Promise<void> {
        await this.leadRepository.delete(leadId);
    }
}

